import { Injectable, inject } from '@angular/core';
import { NavigationService } from '@core/services';
import { TokenService } from '@paypoint-frontend/web-core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private tokenService = inject(TokenService);
  private navigationService = inject(NavigationService);

  //private timer: ReturnType<typeof setTimeout>;

  logout() {
    console.log('logout');
    // localStorage.removeItem('expires_at');
    // localStorage.removeItem('token');
    // localStorage.removeItem('userLogin');
    // clearTimeout(this.timer);
    // this.navigationService.navigateToLogin();
  }

  scheduleLogout() {
    // clearTimeout(this.timer);
    // const timeout = this.tokenService.getLifeTime() - Date.now();
    // if (timeout > 0) {
    //   this.timer = setTimeout(() => this.logout(), timeout);
    // } else {
    //   this.logout();
    // }
  }

  isAuthenticated(): boolean {
    return (
      !!this.tokenService.getToken() && !this.tokenService.isTokenExpired()
    );
  }
}
